import {productDetailsSettings, ProductDetailsSettings} from '../../../bps/components/productDetails/productDetailsSettings';

productDetailsSettings.flags.src.awardInSetImage = '/assets/enzo/frontend-core/staticImages/awardInSet.svg';
productDetailsSettings.flags.src.boxSetImage = '/assets/enzo/frontend-core/staticImages/wood-box.png';
productDetailsSettings.flags.whitelist = ['stoerer', 'new', 'newVintage', 'free', 'savings', 'nonAlcoholic', 'award', 'awardInSet', 'bio', 'vegan', 'boxSetLayer'];

export {productDetailsSettings, ProductDetailsSettings};
